{
  "page": {
    "title": "Settings",
    "subtitle": "Changes apply to new bookings and invoices only",
    "save": "Save settings",
    "saved": "Settings saved"
  },
  "fee": {
    "title": "Default booking fee",
    "percent": "Percentage of the booking amount",
    "fixed": "Fixed amount",
    "percentLabel": "Rate (%)",
    "amountLabel": "Amount ({{currency}})"
  },
  "billing": {
    "title": "Invoice modes",
    "hint": "Owners and coordinators only see the enabled modes on the booking form. At least one.",
    "default": "Default for new bookings"
  },
  "vat": {
    "title": "Value-added tax",
    "enable": "Enable VAT",
    "rate": "Rate (%)",
    "baseFee": "Service fee only",
    "baseTotal": "Invoice total",
    "enabledInfo": "VAT is applied to new invoices only, and the rate is copied to each invoice when it is issued.",
    "disabledInfo": "No VAT at the moment. The VAT line appears on invoices at 0%."
  },
  "invoices": {
    "title": "Invoices",
    "dueDays": "Payment terms (days)",
    "prefix": "Invoice number prefix",
    "prefixHint": "Example: {{example}}",
    "channels": "Delivery channels",
    "sms": "SMS (always)",
    "email": "Email when available",
    "whatsapp": "WhatsApp"
  },
  "alerts": {
    "title": "Alerts",
    "contractWarnDays": "Alert before a contract ends (days)"
  },
  "streampay": {
    "title": "StreamPay connection",
    "testOk": "Connected to StreamPay successfully",
    "testFailed": "Couldn't connect to StreamPay — check the keys in the environment variables",
    "reconcileStarted": "Reconciliation started in the background",
    "envProduction": "Production",
    "envSandbox": "Sandbox",
    "envMock": "Local mock",
    "disconnected": "Not connected",
    "connected": "Connected",
    "untested": "Not tested",
    "keysNote": "API keys are kept in server environment variables and can't be edited from the interface.",
    "webhookUrl": "Notification URL (Webhook)",
    "copyUrl": "Copy URL",
    "copied": "Copied",
    "lastWebhook": "Last notification received",
    "lastReconcile": "Last reconciliation",
    "test": "Test connection",
    "reconcileNow": "Run reconciliation now",
    "lastPoll": "Last payment status check (every {{seconds}} s)",
    "pollSummary": "{{open}} open · {{checked}} checked · {{changed}} changed",
    "pollInterrupted": "stopped early: StreamPay unreachable",
    "events": {
      "title": "Latest StreamPay events",
      "empty": "No events received yet.",
      "event": "Event",
      "outcome": "Outcome",
      "received": "Received",
      "pending": "Processing",
      "outcomes": {
        "applied": "Applied",
        "skipped_already_updated": "Skipped (already updated)",
        "no_change": "No change",
        "ignored_unsupported": "Not used",
        "unknown_entity": "Unknown invoice",
        "error": "Error"
      }
    }
  },
  "coordinators": {
    "title": "Coordinator permissions",
    "hint": "Apply to every coordinator in their portal, for their own bookings only.",
    "create": "Add and edit bookings",
    "confirm": "Confirm bookings",
    "customers": "Register customers",
    "invoices": "Issue invoices"
  }
}
